import { ConsentString } from 'consent-string';
import { isFeatureEnabled } from 'owa-feature-flags';
import { loadGdprAdConsentString } from 'owa-gdpr-ad-consent-string';
import { areAdsEnabled, isGdprAdMarket } from 'owa-mail-ads-shared';
import { getQueryStringParameter } from 'owa-querystring';

export default async function shouldPrompt() {
    if (
        !isFeatureEnabled('fwk-gdprAdsV2') || // GRPR Ads v2 flight is off
        !areAdsEnabled() || // We only need to prompt if this user receives ads
        !isGdprAdMarket() // GDPR only applies to EU
    ) {
        return false;
    }

    let consentString = await loadGdprAdConsentString();

    // If the stored consent string is a valid consent string, we do not prompt
    // Otherwise, we prompt the gdpr prompt
    const consentDataEncodedString = new ConsentString(consentString);
    if (consentDataEncodedString.getCmpId() == 168) {
        // skipgdprcs is a test parameter to force
        const skipConsentStringCheck = getQueryStringParameter('skipgdprcs') == '1';
        if (skipConsentStringCheck) {
            return true;
        }

        return false;
    }

    return true;
}
